import { Component } from '@angular/core';

@Component({
  selector: 'uni-list',
  templateUrl: './uni-list.component.html',
  styleUrls: ['./uni-list.component.scss'],
})
export class UniListComponent { }
